import styled from "styled-components";
import { useTranslation } from "react-i18next";
import React from "react";

export interface LabelProps {
  /**
   * What is the input label
   */
  lbl: string;
  /**
   * What is the input label color?
   */
  lblColor?: string;
}
/**
 * Form Label styles
 */

interface LabelElementProps {
  lblColor: string;
}

const FormLabel = styled.label<LabelElementProps>`
  color: ${(p) => (theme: any) => theme.theme[p.lblColor]};
  font-size: 14px;
  display: block;
  text-align: start;
  padding-bottom: 16px;
  font-weight: normal;
`;

const Label: React.FC<LabelProps> = ({ lbl, lblColor = "Light2" }) => {
  const { t } = useTranslation();

  return (
    <FormLabel lblColor={lblColor} className="col-form-label">
      {t(lbl)}
    </FormLabel>
  );
};
export default Label;
